import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PostImage from './PostImage';

class GridCellContent extends Component {
  render() {
    const { gridCell, inViewClass, innerRef } = this.props;

    return (
      <div
        ref={innerRef}
        className={`grid-cell ${gridCell.classes ? gridCell.classes.join(' ') : ''} ${inViewClass}`}
        id={gridCell.id}
        style={gridCell.bgcolor ? { backgroundColor: `#${gridCell.bgcolor}` } : null}
      >
        {
          gridCell.content.map((contentItem) =>{
            if (contentItem.type === 'img') {
              return (
                <PostImage key={contentItem.id} contentItem={contentItem} />
              );
            }
            if (contentItem.type === 'text') {
              return (
                <p
                  key={contentItem.id}
                  className={`post-item post-text ${contentItem.classes ? contentItem.classes.join(' ') : ''}`}
                  id={contentItem.id ? contentItem.id : null}
                >
                  {contentItem.words}
                </p>
              );
            }
            if (contentItem.type === 'html') {
              return (
                <div
                  key={contentItem.id}
                  className={`post-item ${contentItem.classes ? contentItem.classes.join(' ') : ''}`}
                  id={contentItem.id ? contentItem.id : null}
                  //eslint-disable-next-line
                  dangerouslySetInnerHTML={{ __html: contentItem.content }}
                />
              );
            } // end if
          }) // end map block
        }
      </div>
    );
  } // end render
}

GridCellContent.propTypes = {
  gridCell: PropTypes.shape({}).isRequired,
  inViewClass: PropTypes.string,
  innerRef: PropTypes.func,
};

GridCellContent.defaultProps = {
  inViewClass: '',
  innerRef: null,
};


export default GridCellContent;



// WEBPACK FOOTER //
// ./src/components/GridCellContent.js